module.exports = __webpack_public_path__ + "img/amocrm-logo-white.32ce1a0e.png";